"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProcessTimeline = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var dmn_table_1 = require("./dmn-table");
var verdigris_1 = require("@codametrix/verdigris");
var TimelineStatus = ui_common_1.commonEnums.TimelineStatus;
var noOp = function () { };
var DefaultProps = {
    clickObserver: noOp,
    doubleClick: noOp
};
var getStatusIcon = function (status) {
    if (status === TimelineStatus.STARTED) {
        return ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Location, iconSize: "16", titleText: "Started Process" }));
    }
    else if (status === TimelineStatus.COMPLETE) {
        return ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Check_Circle, iconSize: "16", titleText: "Process Complete" }));
    }
    else if (status === TimelineStatus.IN_PROGRESS) {
        return ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Pending, iconSize: "16", titleText: "In Progress" }));
    }
};
var idForEvent = function (ev) {
    var _a, _b;
    //@ts-ignore
    return (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset.id) !== null && _b !== void 0 ? _b : null;
};
var ProcessTimeline = /** @class */ (function (_super) {
    __extends(ProcessTimeline, _super);
    function ProcessTimeline(props) {
        var _this = _super.call(this, props) || this;
        _this.accordionRef = react_1["default"].createRef();
        _this.containerRef = react_1["default"].createRef();
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {};
        return _this;
    }
    ProcessTimeline.prototype.handleClick = function (ev) {
        var _a;
        ev.preventDefault();
        var itemId = idForEvent(ev);
        var accordionRef = this.accordionRef;
        if (itemId !== null && accordionRef.current !== null) {
            document.querySelectorAll('.accordion-section.highlight').forEach(function (el) {
                el.classList.remove('highlight');
            });
            var el_1 = (_a = document
                .getElementById("stage-".concat(itemId))) === null || _a === void 0 ? void 0 : _a.closest('.accordion-section');
            if (el_1) {
                el_1.classList.add('highlight');
                this.props.clickObserver(itemId);
                setTimeout(function () {
                    el_1.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }, 100);
            }
        }
    };
    ProcessTimeline.prototype.handleDoubleClick = function (ev) {
        var _a;
        var itemId = idForEvent(ev);
        var accordionRef = this.accordionRef;
        if (itemId !== null && accordionRef.current !== null) {
            (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a.toggle(itemId);
            if (!this.state[itemId]) {
                this.handleClick(ev);
            }
            var s = __assign({}, this.state);
            s[itemId] = !s[itemId];
            this.setState(s);
        }
    };
    ProcessTimeline.prototype.render = function () {
        var _a;
        var props = __assign({}, this.props);
        var stages = props.stages;
        var unselectableAccordion = (_a = props.stifleSelection) !== null && _a !== void 0 ? _a : false;
        var lastUpdatedDate = '';
        var lst = stages.map(function (stage, idx) {
            var _a, _b, _c;
            var updateDate = stage.displayDate && typeof stage.displayDate === 'string'
                ? ui_common_1.cmxDateTime.format(stage.displayDate, ui_common_1.cmxDateTime.FORMATS.DATE)
                : 'N/A';
            var displayDate;
            if (idx === 0) {
                displayDate = updateDate;
            }
            else {
                displayDate = updateDate === lastUpdatedDate ? '' : updateDate;
            }
            lastUpdatedDate = updateDate;
            var timeFormat = idx === 0
                ? ui_common_1.cmxDateTime.FORMATS.TIME_WITH_ZONE
                : ui_common_1.cmxDateTime.FORMATS.TIME;
            var updateTime = stage.displayDate && typeof stage.displayDate === 'string'
                ? ui_common_1.cmxDateTime.format(stage.displayDate, timeFormat)
                : 'N/A';
            var peeked = (_a = stage.steps[stage.steps.length - 1]) !== null && _a !== void 0 ? _a : false;
            var statusClass = "status-".concat((_b = stage.status) === null || _b === void 0 ? void 0 : _b.toLowerCase());
            var depthClass = "depth-".concat(stage.depth);
            var header = ((0, jsx_runtime_1.jsxs)("div", __assign({ id: "stage-".concat(stage.key), className: "timeline-item ".concat(statusClass, " ").concat(depthClass) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "timeline-meta-col" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-status ".concat(statusClass) }, { children: getStatusIcon("".concat(stage.status)) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-datetime" }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: "display-datetime" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "display-date" }, { children: displayDate })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "display-time" }, { children: updateTime }))] })) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "timeline-title timeline-description-col" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "stage-title" }, { children: stage.title })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "stage-last-step" }, { children: peeked && peeked.activity.activityDefinition.name })), ' ', (0, jsx_runtime_1.jsxs)("span", __assign({ className: "stage-parent" }, { children: ["Started by: ", (_c = stage.parent) === null || _c === void 0 ? void 0 : _c.title] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "debug-information" }, { children: stage.key }))] }))] }), stage.key));
            var steps = __spreadArray([], __read(stage.steps), false).reverse();
            var stepItems = steps.map(function (step) {
                var _a, _b, _c, _d;
                var eventType = (_c = (_b = (_a = step.activity) === null || _a === void 0 ? void 0 : _a.activityDefinition) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : 'DNE';
                if (eventType === 'startEvent' ||
                    eventType === 'conditionalStartEvent') {
                    return false;
                }
                var activity = step.activity;
                var activityDefinition = activity.activityDefinition;
                var startDate = activity.createdDate;
                var updateDate = activity.lastEndTimestamp || activity.lastStartTimestamp;
                var updateDateMoment = startDate
                    ? ui_common_1.cmxDateTime.format(startDate, ui_common_1.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE)
                    : 'N/A';
                // calculate total duration
                var duration = ui_common_1.cmxDateTime.calculateDuration(startDate, updateDate);
                var seconds = duration.asSeconds() % 60;
                var durationInSeconds = Math.max(seconds, 0);
                var formattedNumber = parseFloat("".concat(durationInSeconds)).toFixed(2);
                var name = (_d = activityDefinition === null || activityDefinition === void 0 ? void 0 : activityDefinition.name) !== null && _d !== void 0 ? _d : activityDefinition.activityId;
                var callsSub = activityDefinition.type === 'callActivity'; // && stepSet.has(activityDefinition.subprocessName as string);
                var displayName = callsSub ? ((0, jsx_runtime_1.jsxs)("a", __assign({ href: "#/", "data-id": activityDefinition.subprocessName }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "step-name" }, { children: name })), "\u21E1", '  ', (0, jsx_runtime_1.jsx)("span", __assign({ className: "debug-information" }, { children: activityDefinition.subprocessName }))] }))) : ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "step-name" }, { children: name })), ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: "debug-information" }, { children: activityDefinition.activityId }))] }));
                var hasRules = step.decisions.length > 0;
                var classes = (0, classnames_1["default"])('timeline-step', { 'has-rules': hasRules });
                return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: classes }, { children: [displayName, ' ', (0, jsx_runtime_1.jsx)("div", __assign({ className: "rules" }, { children: (0, jsx_runtime_1.jsx)(dmn_table_1.DMNTable, { step: step }) })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "duration-readout" }, { children: [formattedNumber, " seconds - ", updateDateMoment] }))] }), activityDefinition.activityId));
            });
            var body = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "timeline-body-item  timeline-description-col" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "timeline-meta-col" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-title timeline-ordered-list" }, { children: (0, jsx_runtime_1.jsx)("ol", __assign({ reversed: true }, { children: stepItems })) }))] })));
            return {
                id: stage.key,
                data: stage,
                header: header,
                body: body
            };
        });
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "process-timeline", ref: this.containerRef, id: "processTimeline", onDoubleClick: this.handleDoubleClick, onClick: this.handleClick }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Accordion, { ref: this.accordionRef, selectable: !unselectableAccordion, items: lst }) })));
    };
    ProcessTimeline.displayName = 'ProcessTimeline';
    ProcessTimeline.defaultProps = {
        stifleSelection: false,
        clickObserver: noOp,
        doubleClick: noOp
    };
    return ProcessTimeline;
}(react_1["default"].Component));
exports.ProcessTimeline = ProcessTimeline;
//# sourceMappingURL=process-timeline.js.map